import type { ReactNode } from 'react';
import { flex } from '../../../styled-system/patterns';

// Card を画面中央に配置するページ向けの外枠
export function CardLayout({ children }: { children: ReactNode }) {
  return (
    <div
      className={flex({
        alignItems: 'center',
        padding: '{spacing.20} {spacing.16}',
        sm: { padding: '{spacing.80}' },
      })}
    >
      {children}
    </div>
  );
}
